import gql from 'graphql-tag';

export const ExperimentalResetCollabService =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation ExperimentalResetCollabService($contentId: String!, $behind: String!) @experimental {
			experimentalResetCollabService(contentId: $contentId, behind: $behind) {
				traceId
			}
		}
	`;
